var _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLadder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_16023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59958 2.97758C8.73658 2.44803 9.21435 2.07812 9.76134 2.07812H13.4888C13.9139 2.07812 14.2246 2.4794 14.1181 2.89092L7.35793 29.0224C7.22093 29.552 6.74316 29.9219 6.19617 29.9219H2.4687C2.04363 29.9219 1.73296 29.5206 1.83941 29.1091L8.59958 2.97758Z",
    fill: "url(#paint0_linear_715_16023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59958 2.97758C8.73658 2.44803 9.21435 2.07812 9.76134 2.07812H13.4888C13.9139 2.07812 14.2246 2.4794 14.1181 2.89092L7.35793 29.0224C7.22093 29.552 6.74316 29.9219 6.19617 29.9219H2.4687C2.04363 29.9219 1.73296 29.5206 1.83941 29.1091L8.59958 2.97758Z",
    fill: "url(#paint1_radial_715_16023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59958 2.97758C8.73658 2.44803 9.21435 2.07812 9.76134 2.07812H13.4888C13.9139 2.07812 14.2246 2.4794 14.1181 2.89092L7.35793 29.0224C7.22093 29.552 6.74316 29.9219 6.19617 29.9219H2.4687C2.04363 29.9219 1.73296 29.5206 1.83941 29.1091L8.59958 2.97758Z",
    fill: "url(#paint2_linear_715_16023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59958 2.97758C8.73658 2.44803 9.21435 2.07812 9.76134 2.07812H13.4888C13.9139 2.07812 14.2246 2.4794 14.1181 2.89092L7.35793 29.0224C7.22093 29.552 6.74316 29.9219 6.19617 29.9219H2.4687C2.04363 29.9219 1.73296 29.5206 1.83941 29.1091L8.59958 2.97758Z",
    fill: "url(#paint3_linear_715_16023)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_715_16023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2661 8.98438L10.5195 6.72656L12.9961 6.625L12.2661 8.98438Z",
    fill: "url(#paint4_linear_715_16023)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_715_16023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4067 15.9394L8.66016 13.6816L11.1367 13.58L10.4067 15.9394Z",
    fill: "url(#paint5_linear_715_16023)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_715_16023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7036 22.8944L6.95703 20.6366L9.43359 20.5351L8.7036 22.8944Z",
    fill: "url(#paint6_linear_715_16023)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_715_16023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8286 29.7968L5.08203 27.5389L7.55859 27.4374L6.8286 29.7968Z",
    fill: "url(#paint7_linear_715_16023)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9755 4.35643C11.0319 4.13484 11.2314 3.97974 11.4601 3.97974L25.3147 3.97974V7.02253L10.683 7.02253C10.4873 7.02253 10.344 6.83819 10.3922 6.64854L10.9755 4.35643Z",
    fill: "url(#paint8_linear_715_16023)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9755 4.35643C11.0319 4.13484 11.2314 3.97974 11.4601 3.97974L25.3147 3.97974V7.02253L10.683 7.02253C10.4873 7.02253 10.344 6.83819 10.3922 6.64854L10.9755 4.35643Z",
    fill: "url(#paint9_linear_715_16023)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9755 4.35643C11.0319 4.13484 11.2314 3.97974 11.4601 3.97974L25.3147 3.97974V7.02253L10.683 7.02253C10.4873 7.02253 10.344 6.83819 10.3922 6.64854L10.9755 4.35643Z",
    fill: "url(#paint10_linear_715_16023)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9755 4.35643C11.0319 4.13484 11.2314 3.97974 11.4601 3.97974L25.3147 3.97974V7.02253L10.683 7.02253C10.4873 7.02253 10.344 6.83819 10.3922 6.64854L10.9755 4.35643Z",
    fill: "url(#paint11_linear_715_16023)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17064 11.2709C9.22703 11.0493 9.42655 10.8942 9.6552 10.8942L23.5098 10.8942V13.937L8.87809 13.937C8.6824 13.937 8.5391 13.7526 8.58736 13.563L9.17064 11.2709Z",
    fill: "url(#paint12_linear_715_16023)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17064 11.2709C9.22703 11.0493 9.42655 10.8942 9.6552 10.8942L23.5098 10.8942V13.937L8.87809 13.937C8.6824 13.937 8.5391 13.7526 8.58736 13.563L9.17064 11.2709Z",
    fill: "url(#paint13_linear_715_16023)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17064 11.2709C9.22703 11.0493 9.42655 10.8942 9.6552 10.8942L23.5098 10.8942V13.937L8.87809 13.937C8.6824 13.937 8.5391 13.7526 8.58736 13.563L9.17064 11.2709Z",
    fill: "url(#paint14_linear_715_16023)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17064 11.2709C9.22703 11.0493 9.42655 10.8942 9.6552 10.8942L23.5098 10.8942V13.937L8.87809 13.937C8.6824 13.937 8.5391 13.7526 8.58736 13.563L9.17064 11.2709Z",
    fill: "url(#paint15_linear_715_16023)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41283 18.2834C7.46921 18.0618 7.66873 17.9067 7.89738 17.9067L21.752 17.9067V20.9495L7.12028 20.9495C6.92459 20.9495 6.78129 20.7652 6.82955 20.5755L7.41283 18.2834Z",
    fill: "url(#paint16_linear_715_16023)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41283 18.2834C7.46921 18.0618 7.66873 17.9067 7.89738 17.9067L21.752 17.9067V20.9495L7.12028 20.9495C6.92459 20.9495 6.78129 20.7652 6.82955 20.5755L7.41283 18.2834Z",
    fill: "url(#paint17_linear_715_16023)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41283 18.2834C7.46921 18.0618 7.66873 17.9067 7.89738 17.9067L21.752 17.9067V20.9495L7.12028 20.9495C6.92459 20.9495 6.78129 20.7652 6.82955 20.5755L7.41283 18.2834Z",
    fill: "url(#paint18_linear_715_16023)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41283 18.2834C7.46921 18.0618 7.66873 17.9067 7.89738 17.9067L21.752 17.9067V20.9495L7.12028 20.9495C6.92459 20.9495 6.78129 20.7652 6.82955 20.5755L7.41283 18.2834Z",
    fill: "url(#paint19_linear_715_16023)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.614 25.2306C5.67039 25.009 5.86991 24.8539 6.09856 24.8539L19.9532 24.8539V27.8967L5.32145 27.8967C5.12576 27.8967 4.98246 27.7123 5.03072 27.5227L5.614 25.2306Z",
    fill: "url(#paint20_linear_715_16023)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.614 25.2306C5.67039 25.009 5.86991 24.8539 6.09856 24.8539L19.9532 24.8539V27.8967L5.32145 27.8967C5.12576 27.8967 4.98246 27.7123 5.03072 27.5227L5.614 25.2306Z",
    fill: "url(#paint21_linear_715_16023)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.614 25.2306C5.67039 25.009 5.86991 24.8539 6.09856 24.8539L19.9532 24.8539V27.8967L5.32145 27.8967C5.12576 27.8967 4.98246 27.7123 5.03072 27.5227L5.614 25.2306Z",
    fill: "url(#paint22_linear_715_16023)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.614 25.2306C5.67039 25.009 5.86991 24.8539 6.09856 24.8539L19.9532 24.8539V27.8967L5.32145 27.8967C5.12576 27.8967 4.98246 27.7123 5.03072 27.5227L5.614 25.2306Z",
    fill: "url(#paint23_linear_715_16023)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_715_16023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2597 2.97758C24.3967 2.44803 24.8745 2.07812 25.4215 2.07812H29.149C29.574 2.07812 29.8847 2.4794 29.7783 2.89092L23.0181 29.0224C22.8811 29.552 22.4033 29.9219 21.8563 29.9219H18.1289C17.7038 29.9219 17.3931 29.5206 17.4996 29.1091L24.2597 2.97758Z",
    fill: "url(#paint24_linear_715_16023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2597 2.97758C24.3967 2.44803 24.8745 2.07812 25.4215 2.07812H29.149C29.574 2.07812 29.8847 2.4794 29.7783 2.89092L23.0181 29.0224C22.8811 29.552 22.4033 29.9219 21.8563 29.9219H18.1289C17.7038 29.9219 17.3931 29.5206 17.4996 29.1091L24.2597 2.97758Z",
    fill: "url(#paint25_radial_715_16023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2597 2.97758C24.3967 2.44803 24.8745 2.07812 25.4215 2.07812H29.149C29.574 2.07812 29.8847 2.4794 29.7783 2.89092L23.0181 29.0224C22.8811 29.552 22.4033 29.9219 21.8563 29.9219H18.1289C17.7038 29.9219 17.3931 29.5206 17.4996 29.1091L24.2597 2.97758Z",
    fill: "url(#paint26_linear_715_16023)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_16023",
    x: 1.81836,
    y: 1.67812,
    width: 13.1203,
    height: 28.2438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.239216 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_16023"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_715_16023",
    x: 10.0195,
    y: 6.125,
    width: 3.47656,
    height: 3.35938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_16023"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_715_16023",
    x: 8.16016,
    y: 13.08,
    width: 3.47656,
    height: 3.35938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_16023"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_715_16023",
    x: 6.45703,
    y: 20.0351,
    width: 3.47656,
    height: 3.35938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_16023"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_715_16023",
    x: 4.58203,
    y: 26.9374,
    width: 3.47656,
    height: 3.35938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_16023"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_715_16023",
    x: 17.4785,
    y: 1.67812,
    width: 13.1203,
    height: 28.2438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.239216 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_16023"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_16023",
    x1: 4.37556,
    y1: 9.37825,
    x2: 11.1809,
    y2: 19.5863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#915F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4D49"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_16023",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.56348 27.6131) rotate(-164.358) scale(2.2651 11.5372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4D49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_16023",
    x1: 11.7044,
    y1: 2.07812,
    x2: 11.7044,
    y2: 3.35811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201766,
    stopColor: "#9F705F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#956455",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_16023",
    x1: 9.65161,
    y1: 26.4219,
    x2: 5.71411,
    y2: 25.1719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.290512,
    stopColor: "#6A4038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A4038",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_16023",
    x1: 11.8281,
    y1: 7.03125,
    x2: 12.1146,
    y2: 8.81599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#592D2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_16023",
    x1: 9.96873,
    y1: 13.9863,
    x2: 10.2552,
    y2: 15.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#592D2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_715_16023",
    x1: 8.2656,
    y1: 20.9413,
    x2: 8.55211,
    y2: 22.7261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#592D2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_715_16023",
    x1: 6.3906,
    y1: 27.8436,
    x2: 6.67711,
    y2: 29.6284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#592D2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_715_16023",
    x1: 12.1286,
    y1: 6.45541,
    x2: 24.317,
    y2: 6.45541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#945B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_16023",
    x1: 17.8488,
    y1: 3.76561,
    x2: 17.8487,
    y2: 4.32811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F684B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F684B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_16023",
    x1: 10.5369,
    y1: 5.84825,
    x2: 11.2154,
    y2: 6.04548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78402D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#965D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_715_16023",
    x1: 19.8699,
    y1: 7.02254,
    x2: 19.8699,
    y2: 6.51561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#653036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#844849",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_715_16023",
    x1: 10.2481,
    y1: 13.3698,
    x2: 22.5064,
    y2: 13.3698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#945B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_715_16023",
    x1: 16.001,
    y1: 10.68,
    x2: 16.001,
    y2: 11.2425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F684B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F684B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_715_16023",
    x1: 8.64716,
    y1: 12.7627,
    x2: 9.32891,
    y2: 12.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78402D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#965D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_715_16023",
    x1: 18.0337,
    y1: 13.937,
    x2: 18.0337,
    y2: 13.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#653036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#844849",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_715_16023",
    x1: 8.49024,
    y1: 20.3824,
    x2: 20.7486,
    y2: 20.3824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#945B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_715_16023",
    x1: 14.2432,
    y1: 17.6926,
    x2: 14.2432,
    y2: 18.2551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F684B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F684B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_715_16023",
    x1: 6.88935,
    y1: 19.7753,
    x2: 7.57109,
    y2: 19.9746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78402D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#965D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_715_16023",
    x1: 16.2759,
    y1: 20.9495,
    x2: 16.2759,
    y2: 20.4426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#653036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#844849",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_715_16023",
    x1: 6.69141,
    y1: 27.3296,
    x2: 18.9498,
    y2: 27.3296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#945B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_715_16023",
    x1: 12.4444,
    y1: 24.6398,
    x2: 12.4444,
    y2: 25.2023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F684B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F684B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_715_16023",
    x1: 5.09052,
    y1: 26.7224,
    x2: 5.77227,
    y2: 26.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78402D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#965D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_715_16023",
    x1: 14.4771,
    y1: 27.8967,
    x2: 14.4771,
    y2: 27.3898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#653036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#844849",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_715_16023",
    x1: 20.0357,
    y1: 9.37825,
    x2: 26.8411,
    y2: 19.5863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#915F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4D49"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_715_16023",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2236 27.6131) rotate(-164.358) scale(2.2651 11.5372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4D49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_715_16023",
    x1: 27.3646,
    y1: 2.07812,
    x2: 27.3646,
    y2: 3.35811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201766,
    stopColor: "#9F705F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#956455",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadder);
export default __webpack_public_path__ + "static/media/Ladder.72ee294d8562997c40051a60539d53b8.svg";
export { ForwardRef as ReactComponent };